import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatHorizontalStepper, MatStep } from '@angular/material';
import { CallModel } from 'src/app/shared/models/calllog.model';

@Component({
  selector: 'app-find-solution-step',
  templateUrl: './find-solution-step.component.html',
  styleUrls: ['./find-solution-step.component.css']
})
export class FindSolutionStepComponent implements OnInit {
  @Input() call : CallModel;
  @Input() stepper : MatHorizontalStepper;
  @Input() mystep : MatStep;
  
  
  constructor() { }

  ngOnInit() {
  }
  onNext()
  {   
    this.mystep.completed = true;
    this.stepper.next();
  }

  onBack()
  {   
    this.mystep.completed = false;
    this.stepper.previous();
  }



}
